import { useRef, useState } from "react";
import { ArrowDownIcon } from "../../assets";
import styles from "./styles.module.scss";
import { useOutsideClick } from "../../hooks";
import { AnimatePresence, motion } from "framer-motion";
import clsx from "clsx";

type SmallSelectorProps = {
  value: string;
  setValue: (value: string) => void;
  data: string[];
};

const SmallSelector: React.FC<SmallSelectorProps> = ({
  value,
  setValue,
  data,
}) => {
  const [isVisiblePicker, setIsVisiblePicker] = useState(false);

  const pickerRef = useRef<HTMLDivElement>(null);

  useOutsideClick(pickerRef, () => setIsVisiblePicker(false));

  return (
    <div className={styles.contentContainer}>
      <div
        ref={pickerRef}
        onClick={() => setIsVisiblePicker(true)}
        style={{
          backgroundColor: isVisiblePicker
            ? "rgba(217, 224, 233, 1)"
            : "#f5f7fa",
        }}
        className={styles.wrapper}
      >
        <span>{value}</span>
        <ArrowDownIcon className={styles.arrow} />
      </div>
      {isVisiblePicker ? (
        <motion.div
          initial={{ opacity: 0.5, y: -60 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -60 }}
          className={styles.pickerContainer}
        >
          {data.map((item, index) => (
            <div
              key={index}
              className={clsx(styles.pickerOption, {
                [styles.selectedOption]: item === value,
              })}
              onClick={() => {
                setValue(item);
                setIsVisiblePicker(false);
              }}
            >
              {item}
            </div>
          ))}
        </motion.div>
      ) : null}
    </div>
  );
};

export default SmallSelector;
